export default () => ({
    counts: {},
    draft: {
        company: null,
        contact: null,
        files: [],
        proof: {
            isWanted: 'NO'
        },
        shippingAddresses: [{}],
        variants: [{
            sorts: [],
            number: 1,
            fields: { }
        }]
    },
    entities: {},
})
